import PropTypes from 'prop-types';

import { trans, useSoyuzLocales } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import CurrencyFormatter from '@spotahome/marketplace-common/src/utils/CurrencyFormatter';

import { useIsUserLogged } from '@spotahome/ui-library';
import { HomecardFormatter } from '@spotahome/ui-library/src/tenant/utils/images';
import { getDateAsUTC } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';
import { useEcommerceManagerFactory } from '@spotahome/ecommerce-tracking';

import { getMonthlyPrice } from '@spotahome/marketplace-common/src/utils/homecards';

import ListingTitle from '../ListingTitle';

import { useListingsAround } from './utils/useListingsAround';

import './ListingsAround.scss';

const getCurrency = homecard =>
  new CurrencyFormatter(
    homecard.currencyLabel,
    homecard.currencySymbol,
    homecard.currencyIsoCode
  );

const ListingsAround = ({ moveIn, moveOut, listingId }) => {
  const { current: currentLocale } = useSoyuzLocales();
  const ecommerceManager = useEcommerceManagerFactory();
  const isUserLogged = useIsUserLogged();
  const listingsAround = useListingsAround(listingId, moveIn, moveOut);

  const currentYear = getDateAsUTC(new Date()).getFullYear();

  const handleHomecardClick = (homecard, position) => () => {
    try {
      ecommerceManager.trackSimilarPropertyClick(
        homecard,
        isUserLogged,
        currentLocale,
        position
      );
    } catch (err) {
      console.error('Failed to handleHomecardClick at additionalListings', {
        err
      });
    }

    SoyuzAnalytics.sendGA4Event('homecard-similar-properties', {
      action: 'click',
      section: 'listing-page'
    });
  };

  return (
    !!listingsAround.length && (
      <div className="listings-around">
        <div className="listings-around__title">
          <ListingTitle>
            {trans('listing.properties_around.title')}
          </ListingTitle>
        </div>
        <div className="listings-around__wrapper">
          {listingsAround.map((homecard, position) => {
            const firstAvailableDate = getDateAsUTC(
              new Date(homecard.firstAvailableDate)
            );
            const firstAvailableYear = firstAvailableDate?.getFullYear();
            const data = {
              ...homecard,
              photos: HomecardFormatter.getPhotos(
                homecard.photoIds,
                homecard.otherPropertyPhotoIds
              ),
              photoUrls: HomecardFormatter.getPhotoUrls(homecard.photoIds),
              monthlyPrice: getMonthlyPrice(homecard.displayPrice)
            };
            return (
              <div key={homecard.id} className="listings-around__item">
                <Homecard
                  isShowStatus
                  data={data}
                  position={position}
                  currency={getCurrency(homecard)}
                  moveIn={moveIn}
                  moveOut={moveOut}
                  tracking="ga-detail-properties-around-card"
                  onClick={handleHomecardClick(homecard, position)}
                  hasLazyLoad
                  showAvailableFromYear={firstAvailableYear !== currentYear}
                  withTransparentBackground
                  pageType="product_page"
                  section="similar_properties"
                />
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

ListingsAround.propTypes = {
  listingId: PropTypes.string.isRequired,
  moveIn: PropTypes.string.isRequired,
  moveOut: PropTypes.string.isRequired
};
export default ListingsAround;
